(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// Update cart bubble fill state based on count
function updateCartBubble() {
  var bubble = document.querySelector('.cart-count-bubble');
  if (!bubble) return;
  var count = parseInt(bubble.textContent, 10);
  if (count > 0) {
    bubble.classList.add('cart-count-bubble--filled');
  } else {
    bubble.classList.remove('cart-count-bubble--filled');
  }
}

// Observe bubble replacement/content changes
function observeBubble() {
  var bubble = document.querySelector('.cart-count-bubble');
  if (bubble && !bubble.hasAttribute('data-observing')) {
    bubble.setAttribute('data-observing', 'true');
    var observer = new MutationObserver(updateCartBubble);
    observer.observe(bubble, { childList: true, subtree: true, characterData: true });
  }
}

// Keep header offset in sync with announcement/utility bar
function updateHeaderOffset() {
  const announcementBar = document.querySelector('.utility-bar');
  const header = document.querySelector('.section-header');
  if (announcementBar && header) {
    const barHeight = announcementBar.offsetHeight;
    header.style.setProperty('--announcement-bar-height', barHeight + 'px');
  }
}
window.addEventListener('DOMContentLoaded', updateHeaderOffset);
window.addEventListener('resize', updateHeaderOffset, { passive: true });

document.addEventListener('DOMContentLoaded', function() {
  updateCartBubble();
  observeBubble();

  var cartIcon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
  if (cartIcon) {
    var containerObserver = new MutationObserver(function() {
      updateCartBubble();
      observeBubble();
    });
    containerObserver.observe(cartIcon, { childList: true, subtree: true });
  }
});

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    // Thresholds to avoid jitter on inertial scroll
    this.UP_THRESHOLD = 10;   // px scroll up required to reveal
    this.DOWN_THRESHOLD = 4;  // ignore tiny down movements

    // Bind + listen for layout changes
    this.recomputeBounds = this.recomputeBounds.bind(this);
    window.addEventListener('resize', this.recomputeBounds, { passive: true });

    // Scroll handling
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    this.createObserver(); // also calls recomputeBounds()

    // Enable transitions after first meaningful setup
    document.documentElement.classList.add('header-initialized');
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.recomputeBounds);
  }

  recomputeBounds() {
    const rect = this.header.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.headerBounds = {
      top: 0,
      bottom: scrollTop + rect.bottom
    };
  }

  createObserver() {
    // One-shot intersection to seed bounds, then compute precisely
    let observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
      // Immediately remeasure using current layout to avoid stale values
      this.recomputeBounds();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const delta = scrollTop - this.currentScrollTop;

    if (scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');

      // Hide when moving down meaningfully
      if (delta > this.DOWN_THRESHOLD) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      }

      // Reveal only after a meaningful upward move
      if (delta < -this.UP_THRESHOLD && !this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (delta < 0 && this.preventReveal) {
        // Short lock to prevent reveal immediately after hide
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else {
      // Above header: reset
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    this.closeMenuDisclosure();
    // this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

document.addEventListener("DOMContentLoaded", () => {
  function hoverMenu(){
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(menu => {
      const megaSummary = menu.querySelector('summary');
      let timeout;
      const HOVER_DELAY = 150;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(timeout);
        menu.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        timeout = setTimeout(() => {
          menu.removeAttribute('open');
        }, HOVER_DELAY);
      });

      // Hover area to reduce accidental closes
      const hoverArea = document.createElement('div');
      hoverArea.className = 'mega-menu-hover-area';
      menu.appendChild(hoverArea);

      hoverArea.style.position = 'absolute';
      hoverArea.style.top = '0';
      hoverArea.style.left = '-2rem';
      hoverArea.style.right = '-2rem';
      hoverArea.style.bottom = '-2rem';
      hoverArea.style.pointerEvents = 'none';
    });
  }

  function initSwiper(){
    const swiper = new Swiper(".mega-collection", {
      slidesPerView: "auto",
      mousewheel: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }

  hoverMenu();
  initSwiper();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      hoverMenu();
      initSwiper();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
